import { MapReportStatuses } from '@/models/MapReport'

const mutations = {
  SET_KEYWORD(state, keyword) {
    state.keyword = keyword
  },
  SET_ADVERTISER_ID(state, advertiserId) {
    state.advertiserId = Number(advertiserId)
  },
  SET_PAGE_NO(state, pageNo) {
    state.pageNo = Number(pageNo)
  },
  SET_SEARCH_STATUS(state, status) {
    state.status = status
  },
  SET_SEARCH_AUTO_GENERATE_STATUS(state, AutoGeneratedStatus) {
    state.isAutoGenerated = AutoGeneratedStatus
  },
  SET_MAP_REPORT(state, mapReport) {
    state.mapReport = mapReport
  },
  RESET(state) {
    state.mapReport = {}
    state.keyword = ''
    state.advertiserId = 0
    state.pageNo = 1
    state.status = MapReportStatuses.Waiting
    state.isAutoGenerated = null
  },
}

export default mutations
